import { createFileRoute } from "@tanstack/react-router";
import { cmsHomeRouteConfig, DecoPageRenderer } from "@decocms/tanstack";
import { deferredSectionLoader } from "@decocms/tanstack/sdk/deferredSectionLoader";
import { withCanonicalFallback } from "~/utils/seo";
import PersonalizedShelf from "~/components/product/PersonalizedShelf";

// CMS `Site.seo` overrides these once block resolution kicks in.
const routeConfig = cmsHomeRouteConfig({
  defaultTitle: "Daniela Tombini: Pijamas Femininos, Lingerie, Biquíni, Fitness, Praia",
  defaultDescription: "Pijamas Femininos, Masculinos e Infantis, Lingerie, Biquíni e Fitness na Loja Daniela Tombini. Vendas por Atacado e Varejo.",
  siteName: "Daniela Tombini",
});

export const Route = createFileRoute("/")({
  ...routeConfig,
  head: withCanonicalFallback(routeConfig.head),
  component: HomePage,
});

function HomePage() {
  const data = Route.useLoaderData() as Record<string, any> | null;

  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Daniela Tombini</h1>
          <p className="text-sm text-base-content/40 mt-2">No CMS page registered for /</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <h1 className="sr-only">
        Daniela Tombini — Pijamas Femininos, Lingerie, Biquíni, Fitness e Praia
      </h1>
      <DecoPageRenderer
        sections={data.resolvedSections ?? []}
        deferredSections={data.deferredSections ?? []}
        deferredPromises={data.deferredPromises}
        pagePath={data.pagePath}
        pageUrl={data.pageUrl}
        loadDeferredSectionFn={deferredSectionLoader}
      />
      <PersonalizedShelf />
    </>
  );
}
